import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "1",
      y: "1",
      width: "24",
      height: "24",
      rx: "12",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17 7L9 19",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }